// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"de425fb5","787":"ab9c0d59","948":"47e00380"}[chunkId] + ".chunk.js";
};